/*
 * Header: the mobile menu toggle, and a flag once the page has scrolled so the
 * header can grow a border instead of carrying one while it sits flush at top.
 */
(function () {
  'use strict';

  function init(header) {
    var toggle = header.querySelector('[data-nb-toggle]');
    var panel = header.querySelector('[data-nb-menu]');

    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });

      // A resize up to desktop leaves the panel open but its trigger hidden.
      window.addEventListener('resize', function () {
        if (window.innerWidth > 989 && !panel.hidden) {
          toggle.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
        }
      }, { passive: true });
    }

    // Out of flow once it has left the screen, hidden until the reader heads
    // back up. The spacer stands in for its height so nothing jumps.
    var spacer = header.parentElement.querySelector('[data-nb-spacer]');

    // Momentum scrolling delivers frames that repeat or overshoot by a pixel,
    // so deciding on one frame's delta makes the header flicker. Travel in one
    // direction is accumulated instead and only a real move flips it.
    var FLIP = 28;      // px in one direction before the header changes state
    var LEAVE = 12;     // px of slack around the threshold, so it cannot chatter

    var lastY = window.scrollY;
    var travel = 0;
    var shown = false;
    var queued = false;

    function apply() {
      queued = false;

      var y = Math.max(0, window.scrollY);
      var delta = y - lastY;
      lastY = y;

      // A change of direction starts the count again
      if ((delta > 0 && travel < 0) || (delta < 0 && travel > 0)) travel = 0;
      travel += delta;

      var h = header.offsetHeight;
      var pinned = header.classList.contains('is-pinned');
      var top = (spacer && pinned ? spacer.offsetTop : header.offsetTop) + h;

      if (y <= top - (pinned ? 0 : LEAVE)) {
        if (pinned) {
          header.classList.remove('is-pinned', 'is-shown');
          if (spacer) { spacer.style.display = ''; spacer.style.height = ''; }
        }
        shown = false;
        travel = 0;
        return;
      }

      if (!pinned) {
        if (spacer) { spacer.style.display = 'block'; spacer.style.height = h + 'px'; }
        header.classList.add('is-pinned');
      }

      if (!shown && travel <= -FLIP) { shown = true; travel = 0; }
      else if (shown && travel >= FLIP) { shown = false; travel = 0; }

      header.classList.toggle('is-shown', shown);
    }

    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(apply);
    }, { passive: true });

    window.addEventListener('resize', apply, { passive: true });
    apply();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-nb-header]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
